import React, { FC } from 'react'
import { registerLocale } from 'react-datepicker'
import ru from 'date-fns/locale/ru'
import { InputDate } from '../styled'
import { IconComponent } from './Icon'
import 'react-datepicker/dist/react-datepicker.css'

export interface DateProps {
	onChange: (val: string) => void
	value: Date | string
	measure: string
	placeholder?: string
}

registerLocale('ru', ru)

export const InputComponentDate: FC<DateProps> = ({
	onChange,
	value,
	measure,
	placeholder = '',
}) => (
	<>
		<InputDate
			popperPlacement="top-end"
			popperModifiers={[
				{
					name: 'offset',
					options: {
						offset: [5, 10],
					},
				},
				{
					name: 'preventOverflow',
					options: {
						rootBoundary: 'viewport',
						tether: false,
						altAxis: true,
					},
				},
			]}
			selected={value}
			onChange={(val) => onChange(val || '')}
			locale="ru"
			dateFormat="dd.MM.yyyy"
			placeholderText={placeholder}
			measure={measure}
		/>
		<IconComponent />
	</>
)
